/*************************************************/
/* MMENU                                         */
/*************************************************/
require("../vendor/jquery.mmenu.all.js");

export function mmenu() {
    let $mobileMenu,
        $mobileMenuTrigger,
        mmenuApi,
        breakpointMaxM = 768,
        resizeTimer;

    const init = function () {
        $mobileMenu = $("#mobile-menu");
        $mobileMenuTrigger = $(".mm-trigger");
        breakpointMaxM = 768;

        $mobileMenu.mmenu(
            {
                // options
                "extensions": [
                    "position-right",
                    "pagedim-black",
                    "border-full",
                    "theme-dark"
                ]
            },
            {
                // configuration
                offCanvas: {
                    pageNodetype: "main",
                    pageSelector: "main"
                },
                classNames: {
                    selected: "custom-mm-selected",
                    panel: "custom-mm-panel"
                }
            }
        );

        // Init mmenu api
        mmenuApi = $mobileMenu.data("mmenu");

        // Open menu
        $mobileMenuTrigger.click(function () {
            if (mmenuApi) {
                mmenuApi.open();
            }
        });

        // Close mmenu if screen width gets over breakpointMaxM (768px)
        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                const width = $(document).width();
                const mmIsOpened = $("html").hasClass("mm-wrapper_opening");
                if (mmenuApi && mmIsOpened && width > breakpointMaxM) {
                    mmenuApi.close();
                }
            }, 250);
        });
    };

    init();
}


// WEBPACK FOOTER //
// ./src/scripts/partials/mmenu.js